import { render } from "./sidebar.vue?vue&type=template&id=2b4b720e"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/layouts/partials/sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b4b720e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b4b720e', __exports__)) {
    console.log('reload')
    api.reload('2b4b720e', __exports__)
  }
  
  module.hot.accept("./sidebar.vue?vue&type=template&id=2b4b720e", () => {
    console.log('re-render')
    api.rerender('2b4b720e', render)
  })

}


export default __exports__